import { configureStore } from '@reduxjs/toolkit';

import { reducer } from 'shared/reducers';
import { IApplicationContext } from 'shared/types/applicationContext';
import { IPreloadedState } from 'shared/types/redux';

/**
 * Хелпер для создания Redux стора
 * @param context IApplicationContext - контекст приложения
 * @param preloadedState IPreloadedState - предзагруженное состояние
 * @param debugEnabled boolean - флаг доступности Redux Devtools на деве
 */
export function createReduxStore(context: IApplicationContext, preloadedState: IPreloadedState, debugEnabled: boolean) {
  const projectName = context.config.getStrict<string>('projectName');

  return configureStore({
    devTools: debugEnabled ? { name: projectName } : false,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: context,
        },
      }),
    preloadedState,
    reducer,
  });
}
